import modal from './modal';

export default {
    init: function (cb) {

        if(typeof window.YT !== 'undefined' && typeof cb === 'function') {
            return cb();
        }

        window.onYouTubeIframeAPIReady = cb;

        // load youtube iframe api
        var tag = document.createElement('script');

        tag.async = true;
        tag.src = 'https://www.youtube.com/iframe_api';

        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    },

    playInline: function ($ele, videoId) {
        if(!$ele.length || !videoId) { return; }

        return new YT.Player($ele.get(0), {
            videoId: videoId,
            width: $ele.width(),
            height: $ele.height(),
            playerVars: {rel: 0},
            events: {
                onReady: function (evt) {
                    var player = evt.target;
                    player.playVideo();
                }
            }
        });
    },

    playInModal: function (videoId) {
        if(!videoId) { return; }

        modal.restoreDefaultClass();
        modal.addCustomClass('modal-video-player');
        modal.setContent('<div class="responsive-embed"><div id="video-player"></div></div>');

        new YT.Player('video-player', {
            videoId: videoId,
            events: {
                onReady: function (evt) {
                    var player = evt.target;
                    modal.events.onOpen(function () {
                        player.playVideo();
                    });
                    modal.events.onClose(function () {
                        modal.restoreDefaultClass();
                        player.destroy();
                    });
                    modal.open();
                }
            }
        })
    },

    playInBackground: function ($ele, videoPlayer, videoId) {	
        if(!$ele.length || !videoId) { return; }
	
        return new YT.Player(videoPlayer.get(0), {
            videoId: videoId,
            width: $ele.width(),
            height: $ele.height(),
            playerVars: { 
                rel: 0,
                autoplay: 1, 
                playsinline: 1,
                playlist: videoId, 
                loop: 1,		
                controls: 0,  
                frameborder: 0,
                modestbranding: 1,
                cc_load_policy: 0
            },
            events: {
                onReady: function (evt) {
                    var player = evt.target;
                    player.mute();
                    player.playVideo();
                }
            }
        });
    },
    playInlineWOControls: function ($ele, videoPlayer, videoId) {
        if(!$ele.length || !videoId) { return; }

        return new YT.Player(videoPlayer.get(0), {
            videoId: videoId,
            width: $ele.width(),
            height: $ele.height(),
            playerVars: { 
                mute: 1,
                autoplay: 1, 
                playsinline: 1,
                playlist: videoId, 
                loop: 1,
                controls: 0,  
                frameborder: 0,
                modestbranding: 1,
                cc_load_policy: 0,
                autohide: 0,
                enablejsapi: 1,
                vq: 'hd1080'
				
            },
            allowfullscreen: 1,
            events: {
                onReady: function (evt) {
                    var player = evt.target;
                    player.mute();
                    player.playVideo();
                }
            }
        });
    },
    playerThumbnail:function ($ele, videoId) {
        if(!$ele.length || !videoId) { return; }

        return new YT.Player($ele.get(0), {
            videoId: videoId,
            width: $ele.width(),
            height: $ele.height(),
            playerVars: {rel: 0},
            autoplay: 0
        });
    }
};
